import { SVGProps } from 'react';

const TextCursorInput = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M12 20h-1a2 2 0 0 1-2-2m0 0a2 2 0 0 1-2 2H6m3-2V6m4 2h7a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-7m-8 0H4a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h1m1-4h1a2 2 0 0 1 2 2m0 0a2 2 0 0 1 2-2h1"
    />
  </svg>
);
export default TextCursorInput;
